exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".evaluation-list-page {\n  width: 100%;\n}\n.evaluation-list-page table{\n  padding: 0px;\n  margin: 0px;\n}\n\n.evaluation-list-page .item-evaluation-list td{\n  vertical-align: middle;\n}\n\n.evaluation-list-page .item-evaluation-list td p{\n  padding: 8px;\n}\n\n.evaluation-list-page .item-evaluation-list .icon-file-evaluation{\n  text-align: center;\n  font-size: 1.8em;\n}\n\n.evaluation-list-page .item-evaluation-list .actions-evaluation {\n  text-align: right !important;\n  padding-right: 16px !important;\n}\n\n.evaluation-list-page .item-evaluation-list .actions-evaluation .remove-data-evaluation{\n  margin-left: 10px;\n}\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/evaluation-list.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/evaluation-list.css
// module chunks = 0